import { render, staticRenderFns } from "./ProgrammazioneAudit.vue?vue&type=template&id=98a54faa"
import script from "./ProgrammazioneAudit.vue?vue&type=script&lang=js"
export * from "./ProgrammazioneAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports